export * from "./ng-scripts-google.component";
export * from "./ng-scripts-pendo.component";
